import { memo } from 'react';
import { Grid, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { InputField } from 'components';

import { ChoiceOptionRowProps } from './types';

export const ChoiceOptionRow = memo(
  ({
    idx,
    name,
    remove,
    itemsLength,
    answerValues,
    setAnswerValuesValue,
    allowReferenceCodes = false,
    optionLabel = 'Select option',
  }: ChoiceOptionRowProps) => (
    <Grid container spacing={2} className="items-center">
      <Grid size={{ md: 4, xs: 12 }}>
        <InputField
          fullWidth
          label={optionLabel}
          placeholder={optionLabel}
          name={`${name}.options.options.${idx}`}
        />
      </Grid>

      {allowReferenceCodes && (
        <Grid size={{ md: 4, xs: 12 }}>
          <InputField
            fullWidth
            label="Value"
            placeholder={String(idx + 1)}
            slotProps={{ inputLabel: { shrink: true } }}
            name={`${name}.options.answerValues.${idx}`}
          />
        </Grid>
      )}

      {itemsLength > 1 && (
        <Grid size={{ xs: 12, md: allowReferenceCodes ? 4 : 8 }}>
          <Button
            color="error"
            onClick={() => {
              remove(idx);
              setAnswerValuesValue(
                answerValues.filter((_, index) => index !== idx),
                true
              );
            }}
          >
            <DeleteIcon />
          </Button>
        </Grid>
      )}
    </Grid>
  )
);

ChoiceOptionRow.displayName = 'ChoiceOptionRow';
